import axios from './axios-with-authentication';
import { Cohort } from '../types';
import { API_BASE_PATH } from './constants';
import { getCachedCohorts } from './clinicalunits';
import { log } from './log';

export async function getCohorts(clinicalUnitId: string): Promise<Cohort[]> {
  const cached = getCachedCohorts(clinicalUnitId);
  if (cached !== undefined) {
    return cached;
  }

  try {
    const { data } = await axios.get<{ id?: string; name?: string }[]>(
      `${API_BASE_PATH}/hcos/clinical-units/${encodeURIComponent(clinicalUnitId)}/cohorts`,
    );
    const items = Array.isArray(data) ? data : [];
    const cohorts = items
      .map((item, index) => {
        const name = String(item.name || '').trim();
        const id = String(item.id || '').trim();
        if (!id || !name) return null;
        return {
          id,
          name,
          clinicalUnitId,
          isDefault: index === 0,
        } as Cohort;
      })
      .filter((cohort): cohort is Cohort => cohort !== null);

    if (cohorts.length > 0) {
      return cohorts;
    }
  } catch (err) {
    log('cohorts/getCohorts', err instanceof Error ? err : new Error(String(err)));
    return [];
  }
  return [];
}
